"use client"; // Mark the page as a Client Component
import LoginForm from "@/components/LoginForm/LoginForm";

export default function LoginPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold text-center text-primary mb-6">
          HenriPay Login
        </h2>
        <LoginForm />
      </div>
    </div>
  );
}
